import { Button } from "react-bootstrap";
import styled, { CSSProperties } from "styled-components";

type Props = {
  onClick: (e: React.MouseEvent) => void;
  text?: string;
  style?: CSSProperties;
};
export const CancelButton = (props: Props) => {
  return (
    <SButton onClick={props.onClick} variant="outline-primary" style={{ ...props.style }}>
      {props.text || "キャンセル"}
    </SButton>
  );
};

const SButton = styled(Button)`
  :disabled {
    border: none;
  }
  :hover {
    background: #cef;
  }
`;
